import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';
import type { ThemeContextValue } from '@/hooks/shared/useThemeColors';

interface MobileSegmentedControlProps {
  tabs: string[];
  selectedIndex: number;
  onTabChange: (index: number) => void;
}

export const MobileSegmentedControl: React.FC<MobileSegmentedControlProps> = ({
  tabs,
  selectedIndex,
  onTabChange,
}) => {
  const styles = useThemedStyles(makeStyles);
  return (
    <View style={styles.container}>
      <View style={styles.segmentedControl}>
        {tabs.map((tab, index) => {
          const isSelected = selectedIndex === index;
          const isFirst = index === 0;
          const isLast = index === tabs.length - 1;

          return (
            <TouchableOpacity
              key={index}
              style={[
                styles.tabButton,
                isSelected && styles.selectedTabButton,
                isFirst && styles.firstTabButton,
                isLast && styles.lastTabButton,
              ]}
              onPress={() => onTabChange(index)}
              accessibilityRole="tab"
              accessibilityState={{ selected: isSelected }}
              accessibilityLabel={tab}
            >
              <Text style={[
                styles.tabButtonText,
                isSelected && styles.selectedTabButtonText,
              ]}>
                {tab}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
};

const makeStyles = ({ colors, semantic }: ThemeContextValue) => StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: colors.bg.base,
  },
  segmentedControl: {
    flexDirection: 'row',
    backgroundColor: semantic.background.tertiary,
    borderRadius: 9,
    padding: 2,
  },
  tabButton: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 12,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 7,
  },
  selectedTabButton: {
    backgroundColor: colors.card.bg,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.15,
    shadowRadius: 2,
    elevation: 2,
  },
  firstTabButton: {
    marginRight: 1,
  },
  lastTabButton: {
    marginLeft: 1,
  },
  tabButtonText: {
    fontSize: 13,
    fontWeight: '400',
    color: colors.text.primary,
  },
  selectedTabButtonText: {
    fontWeight: '600',
  },
});

